import type { ReactElement } from 'react';
import { Separator, type SeparatorProps } from 'react-aria-components';
import cx from 'clsx';
import styles from './option-divider.module.css';

export function OptionDivider({ className, ...props }: SeparatorProps): ReactElement {
  return <Separator className={cx(styles.separator, className)} {...props} />;
}
